<template>
<!--  <div>-->


    <b-form-group  label-for="user-name">
      <!--            <validation-provider-->
      <!--                #default="{ errors }"-->
      <!--                :name="fieldsData.name"-->
      <!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->

<!--      <div>-->

        <label  v-html="fieldsData.hint[selectlang]"></label>
<!--      <div class="row" v-for="(filedsData1,index) in fieldsData.field" :key="index">-->


        <b-form-input
            :required="isRequired(fieldsData.required)"
                       :maxLength="fieldsData.maxLength"
                       :minLength="fieldsData.minLength"
                       :min="fieldsData.minValue"
                       :max="fieldsData.maxValue"
            :value=fieldsData.id

                      :placeholder="fieldsData.hint[selectlang]"
                      :type="fieldsData.inputType =='phone'?'number':fieldsData.inputType"
                       @keypress="(fieldsData.inputType === 'phone' || fieldsData.inputType === 'number') ? onlyNumber($event) : ''"
                      class="form-control"
            :formatter="formatterFunction"

                       @input="UpdateValue($event)"
        />
<!--          oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"-->
      <!--      <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->
      <small class="text-danger" v-if="errorshow">{{ fieldsData.validationText[selectlang] }}</small>
    </b-form-group>
<!--  </div>-->
</template>

<script>
// import {ValidationProvider} from "vee-validate";
// import {required} from "@validations";
export default {
  components: {
    // ValidationProvider,
  },
  // props: {
  //   fieldsData: {
  //     // type: Object,
  //     // default: () => fieldsData,
  //   },
  // },
  data() {
    return {
      // errors: [],
      DataArray:{},
      errorshow:false,
      // required,
    };
  },
  props: ['fieldsData','selectlang'],



  created() {

  },


  methods: {
    formatterFunction(e) {
      return String(e).substring(0, this.fieldsData.maxLength);
    },

    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    UpdateValue(value) {

        const input = event.target;
        const maxLength = input.getAttribute('maxLength');
        if (input.value.length > maxLength) {
          input.value = input.value.slice(0, maxLength);
        }


      this.$emit('input',value)
      const lenmax =parseInt(this.fieldsData.maxValue);


      const lenmin=parseInt(this.fieldsData.minValue);
      const lenval=parseInt(value);

      this.$emit('input',value)
      if (lenval < lenmin || lenval > lenmax){

        this.errorshow=true;
      }

      else
      {

        this.errorshow=false;
      }

    },

    // updateFormData() {
    //   const payload = {
    //     key: this.fieldsData.name,
    //     value: this.DataArray[this.fieldsData.name]
    //   };
    //   // Emit event with payload containing both key and value
    //   this.$emit('updateFieldData', payload);
    // },

    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },


  }
}
</script>

<style>
/* Add your styles here */
</style>
